// extracted by mini-css-extract-plugin
module.exports =  {"root":"IIj_Oa4SmYD4FVWO8QkJ","preventLabelOverflow":"ylZCGYIiHODdm1DLdey4","formWrapperWithLabels":"ycAtiMlcSWT_bQPyK9Kw","labelAlwaysOn":"GZIb2XQV6xTQYRbcC3GM"};